import { InputNumber } from "primereact/inputnumber";
import { Fragment } from "react";
import { NumericFormat } from "react-number-format";

const ProfitLoss = ({ purchasePriceInfo, handleInvestmentInputChange }) => {
    const renderIncomeInput = () => {
        return (
            <Fragment>
                <div className="grid">
                    <div className="col-12">
                        <div className="">
                            <label className="mb-2">Rental Income</label>
                            <div className="p-inputgroup">
                                <InputNumber
                                    className="vw-inputnumber-with-border"
                                    autoComplete="off"
                                    required={true}
                                    prefix="$ "
                                    name="income_rental"
                                    disabled={true}
                                    minFractionDigits={0}
                                    maxFractionDigits={0}
                                    // onValueChange={(e) => {
                                    //     dispatch(
                                    //         changeLeftCalculations({
                                    //             name: "purchasePrice",
                                    //             value: e.value,
                                    //         })
                                    //     );
                                    //     handleLeftCalculations(
                                    //         "purchasePrice",
                                    //         e.value
                                    //     );
                                    // }}
                                    value={purchasePriceInfo?.income_rental}
                                />
                            </div>
                        </div>
                    </div>
                </div>
                <div className="grid">
                    <div className="col-12">
                        <div className="">
                            <label className="mb-2">Total</label>
                            <div className="p-inputgroup">
                                <InputNumber
                                    className="vw-inputnumber-with-border"
                                    autoComplete="off"
                                    required={true}
                                    prefix="$ "
                                    name="income_total"
                                    disabled={true}
                                    minFractionDigits={0}
                                    maxFractionDigits={0}
                                    // onValueChange={(e) => {
                                    //     dispatch(
                                    //         changeLeftCalculations({
                                    //             name: "purchasePrice",
                                    //             value: e.value,
                                    //         })
                                    //     );
                                    //     handleLeftCalculations(
                                    //         "purchasePrice",
                                    //         e.value
                                    //     );
                                    // }}
                                    value={purchasePriceInfo?.income_total}
                                />
                            </div>
                        </div>
                    </div>
                </div>
            </Fragment>
        );
    };

    const renderExpensesInput = () => {
        return (
            <Fragment>
                <div className="grid">
                    <div className="col-12">
                        <div className="">
                            <label className="mb-2">Interest</label>
                            <div className="p-inputgroup">
                                <InputNumber
                                    className="vw-inputnumber-with-border"
                                    autoComplete="off"
                                    required={true}
                                    prefix="$ "
                                    name="expenses_interest"
                                    disabled={true}
                                    minFractionDigits={0}
                                    maxFractionDigits={0}
                                    // min={0}
                                    // onValueChange={(e) => {
                                    //     dispatch(
                                    //         changeLeftCalculations({
                                    //             name: "purchasePrice",
                                    //             value: e.value,
                                    //         })
                                    //     );
                                    //     handleLeftCalculations(
                                    //         "purchasePrice",
                                    //         e.value
                                    //     );
                                    // }}
                                    value={purchasePriceInfo?.expenses_interest}
                                />
                            </div>
                        </div>
                    </div>
                </div>
                <div className="grid">
                    <div className="col-12">
                        <div className="">
                            <label className="mb-2">Property Taxes</label>
                            <div className="p-inputgroup">
                                <InputNumber
                                    className="vw-inputnumber-with-border"
                                    autoComplete="off"
                                    required={true}
                                    prefix="$ "
                                    name="expenses_propertyTax"
                                    disabled={true}
                                    minFractionDigits={0}
                                    maxFractionDigits={0}
                                    // min={0}
                                    // onValueChange={(e) => {
                                    //     dispatch(
                                    //         changeLeftCalculations({
                                    //             name: "purchasePrice",
                                    //             value: e.value,
                                    //         })
                                    //     );
                                    //     handleLeftCalculations(
                                    //         "purchasePrice",
                                    //         e.value
                                    //     );
                                    // }}
                                    value={purchasePriceInfo?.expenses_propertyTax}
                                />
                            </div>
                        </div>
                    </div>
                </div>
                <div className="grid">
                    <div className="col-12">
                        <div className="">
                            <label className="mb-2">HOA</label>
                            <div className="flex">
                            <div className="p-inputgroup">
                                <NumericFormat
                                    className="input-field"
                                    style={{"width":"240px"}}
                                    thousandSeparator=","
                                    autoComplete="off"
                                    required={true}
                                    prefix="$ "
                                    name="expenses_hoa"
                                    disabled={false}
                                    decimalScale={0}
                                    onBlur={(values) => {
                                    handleInvestmentInputChange("expenses_hoa", values);
                                    }}
                                    // min={0}
                                    // onValueChange={(e) => {
                                    //     dispatch(
                                    //         changeLeftCalculations({
                                    //             name: "purchasePrice",
                                    //             value: e.value,
                                    //         })
                                    //     );
                                    //     handleLeftCalculations(
                                    //         "purchasePrice",
                                    //         e.value
                                    //     );
                                    // }}
                                    value={purchasePriceInfo?.expenses_hoa}
                                /> 
                            </div> <label style={{marginTop:"10px", marginLeft:"5px"}}>(Annual)</label> </div>
                        </div>
                    </div>
                </div>
                <div className="grid">
                    <div className="col-12">
                        <div className="">
                            <label className="mb-2">Insurance</label>
                             <div className="flex">
                            <div className="p-inputgroup">
                                <NumericFormat
                                    className="input-field"
                                    style={{"width":"290px"}}
                                    thousandSeparator=","
                                    autoComplete="off"
                                    required={true}
                                    prefix="$ "
                                    decimalScale={0}
                                    name="expenses_insurance"
                                    disabled={false}
                                    onBlur={(values) => {
                                    handleInvestmentInputChange("expenses_insurance", values);
                                    }}
                                    // min={0}
                                    // onValueChange={(e) => {
                                    //     dispatch(
                                    //         changeLeftCalculations({
                                    //             name: "purchasePrice",
                                    //             value: e.value,
                                    //         })
                                    //     );
                                    //     handleLeftCalculations(
                                    //         "purchasePrice",
                                    //         e.value
                                    //     );
                                    // }}
                                    value={purchasePriceInfo?.expenses_insurance}
                                /></div>
                                <label style={{marginTop:"10px", marginLeft:"5px"}}>(Annual)</label></div>
                            
                        </div>
                    </div>
                </div>
                <div className="grid">
                    <div className="col-12">
                        <div className="">
                            <label className="mb-2">Maintenance</label>
                            <div className="p-inputgroup">
                                <InputNumber
                                    className="vw-inputnumber-with-border"
                                    autoComplete="off"
                                    required={true}
                                    prefix="$ "
                                    name="expenses_maintenance"
                                    minFractionDigits={0}
                                    maxFractionDigits={0}
                                    disabled={true}
                                    // min={0}
                                    // onValueChange={(e) => {
                                    //     dispatch(
                                    //         changeLeftCalculations({
                                    //             name: "purchasePrice",
                                    //             value: e.value,
                                    //         })
                                    //     );
                                    //     handleLeftCalculations(
                                    //         "purchasePrice",
                                    //         e.value
                                    //     );
                                    // }}
                                    value={purchasePriceInfo?.expenses_maintenance}
                                />
                            </div>
                        </div>
                    </div>
                </div>
                <div className="grid">
                    <div className="col-12">
                        <div className="">
                            <label className="mb-2">Property Management</label>
                            <div className="p-inputgroup">
                                <InputNumber
                                    className="vw-inputnumber-with-border"
                                    autoComplete="off"
                                    required={true}
                                    prefix="$ "
                                    minFractionDigits={0}
                                    maxFractionDigits={0}
                                    name="expenses_propertyManagement"
                                    disabled={true}
                                    // min={0}
                                    // onValueChange={(e) => {
                                    //     dispatch(
                                    //         changeLeftCalculations({
                                    //             name: "purchasePrice",
                                    //             value: e.value,
                                    //         })
                                    //     );
                                    //     handleLeftCalculations(
                                    //         "purchasePrice",
                                    //         e.value
                                    //     );
                                    // }}
                                    value={purchasePriceInfo?.expenses_propertyManagement}
                                />
                            </div>
                        </div>
                    </div>
                </div>
                <div className="grid">
                    <div className="col-12">
                        <div className="">
                            <label className="mb-2">Utilities</label>
                             <div className="flex">
                            <div className="p-inputgroup">
                                <NumericFormat
                                    className="input-field"
                                    style={{"width":"290px"}}
                                    thousandSeparator=","
                                    decimalScale={0}
                                    autoComplete="off"
                                    required={true}
                                    prefix="$ "
                                    name="expenses_utilities"
                                    disabled={false}
                                    onBlur={(values) => {
                                    handleInvestmentInputChange("expenses_utilities", values);
                                    }}
                                    // min={0}
                                    // onValueChange={(e) => {
                                    //     dispatch(
                                    //         changeLeftCalculations({
                                    //             name: "purchasePrice",
                                    //             value: e.value,
                                    //         })
                                    //     );
                                    //     handleLeftCalculations(
                                    //         "purchasePrice",
                                    //         e.value
                                    //     );
                                    // }}
                                    value={purchasePriceInfo?.expenses_utilities}
                                />
                            </div>
                            <label style={{marginTop:"10px", marginLeft:"5px"}}>(Annual)</label></div>
                        </div>
                    </div>
                </div>
                <div className="grid">
                    <div className="col-12">
                        <div className="">
                            <label className="mb-2">Operating Expenses</label>
                            <div className="p-inputgroup">
                                <InputNumber
                                    className="vw-inputnumber-with-border"
                                    autoComplete="off"
                                    required={true}
                                    prefix="$ "
                                    name="expenses_operatingexpenses"
                                    minFractionDigits={0}
                                    maxFractionDigits={0}
                                    disabled={true}
                                    onValueChange={handleInvestmentInputChange}
                                    // min={0}
                                    // onValueChange={(e) => {
                                    //     dispatch(
                                    //         changeLeftCalculations({
                                    //             name: "purchasePrice",
                                    //             value: e.value,
                                    //         })
                                    //     );
                                    //     handleLeftCalculations(
                                    //         "purchasePrice",
                                    //         e.value
                                    //     );
                                    // }}
                                    value={purchasePriceInfo?.expenses_operatingexpenses}
                                />
                            </div>
                        </div>
                    </div>
                </div>
                <div className="grid">
                    <div className="col-12">
                        <div className="">
                            <label className="mb-2">NOI</label>
                            <div className="p-inputgroup">
                                <InputNumber
                                    className="vw-inputnumber-with-border"
                                    autoComplete="off"
                                    required={true}
                                    prefix="$ "
                                    name="expenses_noi"
                                    disabled={true}
                                    minFractionDigits={0}
                                    maxFractionDigits={0}
                                    onValueChange={handleInvestmentInputChange}
                                    // min={0}
                                    // onValueChange={(e) => {
                                    //     dispatch(
                                    //         changeLeftCalculations({
                                    //             name: "purchasePrice",
                                    //             value: e.value,
                                    //         })
                                    //     );
                                    //     handleLeftCalculations(
                                    //         "purchasePrice",
                                    //         e.value
                                    //     );
                                    // }}
                                    value={purchasePriceInfo?.expenses_noi}
                                />
                            </div>
                        </div>
                    </div>
                </div>
                <div className="grid">
                    <div className="col-12">
                        <div className="">
                            <label className="mb-2">Total</label>
                            <div className="p-inputgroup">
                                <InputNumber
                                    className="vw-inputnumber-with-border"
                                    autoComplete="off"
                                    required={true}
                                    minFractionDigits={0}
                                    maxFractionDigits={0}
                                    prefix="$ "
                                    name="expenses_total"
                                    disabled={true}
                                    // min={0}
                                    // onValueChange={(e) => {
                                    //     dispatch(
                                    //         changeLeftCalculations({
                                    //             name: "purchasePrice",
                                    //             value: e.value,
                                    //         })
                                    //     );
                                    //     handleLeftCalculations(
                                    //         "purchasePrice",
                                    //         e.value
                                    //     );
                                    // }}
                                    value={purchasePriceInfo?.expenses_total}
                                />
                            </div>
                        </div>
                    </div>
                </div>
                <div className="grid">
                    <div className="col-12">
                        <div className="">
                            <label className="mb-2">Profit / Loss</label>
                            <div className="p-inputgroup">
                                <InputNumber
                                    className="vw-inputnumber-with-border"
                                    autoComplete="off"
                                    required={true}
                                    prefix="$ "
                                    name="expenses_profitloss"
                                    disabled={true}
                                    minFractionDigits={0}
                                    maxFractionDigits={0}
                                    // min={0}
                                    // onValueChange={(e) => {
                                    //     dispatch(
                                    //         changeLeftCalculations({
                                    //             name: "purchasePrice",
                                    //             value: e.value,
                                    //         })
                                    //     );
                                    //     handleLeftCalculations(
                                    //         "purchasePrice",
                                    //         e.value
                                    //     );
                                    // }}
                                    value={purchasePriceInfo?.expenses_profitloss}
                                />
                            </div>
                        </div>
                    </div>
                </div>
                <div className="grid">
                    <div className="col-12">
                        <div className="">
                            <label className="mb-2">Depreciation</label>
                            <div className="p-inputgroup">
                                <InputNumber
                                    className="vw-inputnumber-with-border"
                                    autoComplete="off"
                                    required={true}
                                    prefix="$ "
                                    name="land"
                                    minFractionDigits={0}
                                    maxFractionDigits={0}
                                    disabled={true}
                                    // min={0}
                                    // onValueChange={(e) => {
                                    //     dispatch(
                                    //         changeLeftCalculations({
                                    //             name: "purchasePrice",
                                    //             value: e.value,
                                    //         })
                                    //     );
                                    //     handleLeftCalculations(
                                    //         "purchasePrice",
                                    //         e.value
                                    //     );
                                    // }}
                                    value={purchasePriceInfo?.expenses_depreciation}
                                />
                            </div>
                        </div>
                    </div>
                </div>
                <div className="grid">
                    <div className="col-12">
                        <div className="">
                            <label className="mb-2">Taxable Income</label>
                            <div className="p-inputgroup">
                                <InputNumber
                                    className="vw-inputnumber-with-border"
                                    autoComplete="off"
                                    required={true}
                                    prefix="$ "
                                    minFractionDigits={0}
                                    maxFractionDigits={0}
                                    name="expenses_taxable_income"
                                    disabled={true}
                                    // min={0}
                                    // onValueChange={(e) => {
                                    //     dispatch(
                                    //         changeLeftCalculations({
                                    //             name: "purchasePrice",
                                    //             value: e.value,
                                    //         })
                                    //     );
                                    //     handleLeftCalculations(
                                    //         "purchasePrice",
                                    //         e.value
                                    //     );
                                    // }}
                                    value={purchasePriceInfo?.expenses_taxable_income}
                                />
                            </div>
                        </div>
                    </div>
                </div>
            </Fragment>
        );
    };

    const renderInputs = () => {
        return (
            <Fragment>
                <div className="grid">
                    <div className="col-6">
                        <h4>Income</h4>
                        {renderIncomeInput()}
                    </div>

                    <div className="col-6">
                        <h4>Expenses</h4>{renderExpensesInput()}</div>
                </div>
            </Fragment>
        );
    };

    return renderInputs();
};

export default ProfitLoss;
